import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ThemeProvider, CssBaseline, GlobalStyles } from "@mui/material";
import reportWebVitals from "./reportWebVitals";
import getTheme from "./theme-layout/theme";
import { Provider } from "react-redux";
import store from "./redux/store";
import ApiLoader from "./shared-components/apiLoader";

const Root = () => {
  const theme = getTheme("light");
  const globalStyles = (
    <GlobalStyles
      styles={(theme) => ({
        html: {
          "--primary-main": theme.palette.primary.main,
          "--primary-darker": theme.palette.primary.dark,
        },
      })}
    />
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {globalStyles}
      <App />
    </ThemeProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <Suspense fallback={<ApiLoader />}>
      <Root />
    </Suspense>
  </Provider>
);

reportWebVitals();